import {
  getInvoiceList as getInvoiceListAPI,
  getProgressClaimList as getProgressClaimListAPI,
  saveInvoice as saveInvoiceAPI,
  downloadProjectProgressBreakup as downloadProjectProgressBreakupAPI,
  downloadProjectInvoice as downloadProjectInvoiceAPI,
  getInvoiceAndProgressClaimList as getInvoiceAndProgressClaimListAPI,
  deleteProgressClaim as deleteProgressClaimAPI,
  getProjectCustomer as getProjectCustomerAPI,
  revertToDraftProgressClaim as revertToDraftProgressClaimAPI,
  getRetentionList as getRetentionListAPI,
  getTenantRetentionTotal as getTenantRetentionTotalAPI
} from '../api/invoice.api'

export const getInvoiceList = (projectId, startDate, endDate) => {
  return (dispatch, getState) => {
    const allowedModules = getState().project.allowedModules || [];
    return getInvoiceListAPI(projectId, startDate, endDate, allowedModules)
  }
}

export const getProgressClaimList = (query) => {
  return (dispatch, getState) => {
    return getProgressClaimListAPI(query)
  }
}

export const saveInvoice = (query) => {
  return (dispatch, getState) => {
    return saveInvoiceAPI(query)
  }
}

export const downloadProjectProgressBreakup = (id, format, tempId) => {
  return (dispatch, getState) => {
    return downloadProjectProgressBreakupAPI(id, format, tempId)
  }
}

export const downloadProjectInvoice = (id, format, tempId) => {
  return (dispatch, getState) => {
    return downloadProjectInvoiceAPI(id, format, tempId)
  }
}

export const getInvoiceAndProgressClaimList = (projectId) => {
  return (dispatch, getState) => {
    return getInvoiceAndProgressClaimListAPI(projectId)
  }
}

export const deleteProgressClaim = (optionId, type) => {
  return (dispatch, getState) => {
    return deleteProgressClaimAPI(optionId, type)
  }
}

export const getProjectCustomer = (id) => {
  return (dispatch, getState) => {
    return getProjectCustomerAPI(id)
  }
}

export const revertToDraftProgressClaim = (id) => {
  return (dispatch, getState) => {
    return revertToDraftProgressClaimAPI(id)
  }
}
export const getRetentionList = (params) => {
  return (dispatch, getState) => {
    const allowedModules = getState().project.allowedModules || [];
    return getRetentionListAPI({ ...params, allowedModules });
  }
}
export const getTenantRetentionTotal = (params) => {
  return (dispatch, getState) => {
    const allowedModules = getState().project.allowedModules || [];
    return getTenantRetentionTotalAPI({ ...params, allowedModules });
  }
}
